import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { IBalooSettings } from '@fi-app/external-platform-integration/baloo/baloo';
import { BalooService } from '@fi-app/external-platform-integration/baloo/baloo.service';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { AppTextService } from '@fi-shared/app-text';
import {
    FiToggleSwitchLabelAlign,
    FiToggleSwitchSliderColorClass,
} from '@fi-shared/fi-toggle-switch/fi-toggle-switch.component';
import { SaveChangesWarningService } from '@fi-shared/fi-shared-services/save-changes-warning.service';

@Component({
    selector: 'baloo-settings',
    templateUrl: './baloo-settings.component.html',
    styleUrls: ['./baloo-settings.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'baloo-settings' },
    standalone: false,
})
export class BalooSettingsComponent implements OnInit {
    @Input() balooSettings: IBalooSettings;

    constructor(
        private balooService: BalooService,
        private customerDataService: FiCustomerDataService,
        private appTextService: AppTextService,
        private saveChangesWarningService: SaveChangesWarningService,
    ) {}

    ngOnInit() {
        this.saveChangesWarningService.start(() => this.balooSettings);
    }

    getCustomerDisplayName(): string {
        return this.customerDataService.customerData.DisplayName;
    }

    isTestCustomer(): boolean {
        return this.customerDataService.isTestCustomer();
    }

    getToggleValueLabel(): string {
        return this.appTextService.get(this.balooSettings.IsAutoSyncEnabled ? 'on' : 'off');
    }

    saveSettings() {
        this.saveChangesWarningService.stop();
        this.balooService.saveSettings(this.balooSettings).then(() => {
            this.balooService.getBalooSettings().then((data: IBalooSettings) => {
                this.balooSettings = data;
                this.saveChangesWarningService.start(() => this.balooSettings);
            });
        });
    }

    isTestActionsEnabled() {
        return true;
        //return this.userDataService.getUserData()?.CanLoginSupportSession;
    }

    getApiResponse() {
        this.balooService.getApiResponse();
    }

    deleteAllBalooGroups() {
        this.balooService.deleteAllBalooGroups();
    }

    protected readonly FiToggleSwitchLabelAlign = FiToggleSwitchLabelAlign;
    protected readonly FiToggleSwitchSliderColorClass = FiToggleSwitchSliderColorClass;
}
